import { Checkbox } from "../ui/checkbox";
import { sanitizeDisplayText } from "../../utils/priceUtils";

/**
 * Checkbox Question component for multi-select
 */
export const CheckboxQuestion = ({ 
  question,
  selectedValues = [],
  onChange,
  className = ""
}) => {
  const handleToggle = (value, checked) => {
    if (checked) {
      onChange([...selectedValues, value]);
    } else {
      onChange(selectedValues.filter(v => v !== value));
    }
  };
  
  return (
    <div className={`space-y-3 ${className}`}>
      {question.options.map((option) => {
        const isChecked = selectedValues.includes(option.value);
        return (
          <label
            key={option.value}
            className={`flex items-center gap-4 p-4 bg-gray-50 border rounded-xl cursor-pointer transition-all hover:border-[#0FA3B1]/50 ${
              isChecked
                ? "border-[#0FA3B1] bg-[#0FA3B1]/5"
                : "border-gray-200"
            }`}
            data-testid={`option-${option.value}`}
          >
            <Checkbox
              checked={isChecked}
              onCheckedChange={(checked) => handleToggle(option.value, checked)}
              className="border-2 border-gray-300 data-[state=checked]:bg-[#0FA3B1] data-[state=checked]:border-[#0FA3B1]"
            />
            <span className="text-[#1F2933] flex-1">
              {sanitizeDisplayText(option.label)}
            </span>
          </label>
        );
      })}
    </div>
  );
};

export default CheckboxQuestion;
